import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * ai 获取图片列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	getImageList( params={} ) {
		return request({
	    url: baseUrl + '/ai/image/list',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * ai 获取人脸检测记录列表
	**/
	getFaceResult(params={}) {
		return request({
		url: baseUrl + '/ai/image/face',
		method: 'GET',
		params
	  })
	}
	
}